<template>
    <CandidateJobListing />
</template>
<script>
import CandidateJobListing from '@/views/pages/public/candidateJob/candidateJobListing'
import i18n from "@/i18n";

export default {
    page: {
        title: i18n.t("module.job"),
    },
    components: { CandidateJobListing },
    data() {
        return {

        };
    },
}
</script>